// src/pages/Users.js
import { useState, useEffect } from "react";
import axios from "axios";
import { BACKEND_BASE } from './constant';
import "./Users.css"; // Import the CSS file
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Referral = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${BACKEND_BASE}/referralData`);
        setData(response.data);
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <div className="admin-container">
      <Button className="sticky-back-button" onClick={() => navigate('/')} style={{backgroundColor:"rgb(72, 39, 110)"}}>Back</Button>
      {loading ? (
        <p className="text-center my-2">Loading...</p>
      ) : data.length > 0 ? (
        <div className="table-container">
          <table className="styled-table">
            <thead>
              <tr>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Count</th>
                <th>People Referred</th>
                <th>Email</th>

              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr key={item.uniqueId}>
                 
                  
                  <td>{item.firstName || "N/A"}</td>
                  <td>{item.lastName || "N/A"}</td>
                  <td>{item.referralCount}</td>
                  <td>
                    {Array.isArray(item.referredUsers) ? item.referredUsers.length===0?"No referrals":item.referredUsers.join(", ") : "N/A"}
                  </td>
                  <td>{item.email || "N/A"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>Empty Data</p>
      )}
    </div>
  );
};

export default Referral;
